import { useMediaQuery } from '@react-hook/media-query';

const IsTablet = (des, mob) => {
  const mediaQ = useMediaQuery('only screen and (min-width: 750px)');
  return mediaQ ? des : mob;
};

export default IsTablet;
